import React, { useEffect, useState } from "react";
import "./dashboard.scss";

import HeaderBar from "../../components/headerBar/HeaderBar";
import OptionBox from "./components/optionBox/OptionBox";
import VoidSpace from "../../components/voidSpace/VoidSpace";
import AssociationDetails from "./components/associationDetails/AssociationDetails";
import InviteModal from "./components/inviteModal/InviteModal";

import PersonAddAltIcon from "@mui/icons-material/PersonAddAlt";
import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";
import StatisticBox from "./components/statisticsBox/StatisticBox";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";

import { t } from "i18next";
import { setGlobalState } from "../../utils/state";
import { dataOptions } from "./data/options";
import { useParams } from "react-router-dom";
import { isEmpty } from "../../utils/validation";
import { getDashboardAssociationWS } from "./api/dashboardApi";
import { Col, Row, Stack } from "react-bootstrap";
import { useScreenSize } from "../../ScreenSizeContext";
import VolunteerTable from "./components/volunteerTable/VolunteerTable";

const Dashboard = () => {
  const { id_association } = useParams();

  const isPC = useScreenSize();
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [options, setOptions] = useState([]);
  const [data, setData] = useState([]);

  useEffect(() => {
    setGlobalState("selectedIdBottomBar", 2);

    getDashboardAssociationWS({ id_association })
      .then((res) => {
        setData(res);
      })
      .catch((err) => console.error(err));

    setOptions(dataOptions);
  }, []);

  return (
    <>
      <HeaderBar title={t("dashboard.title")} back={true} />
      <div className="dashboard-box container-responsive">
        {/**HEADER della dashboard */}
        <Stack gap={4}>
          <Stack gap={1}>
            <span className="paragraph-title-dashboard">
              {t("dashboard.general")}
            </span>
            <Row
              sm={1}
              md={1}
              lg={2}
              xl={2}
              className="g-3 d-flex align-items-stretch"
            >
              <Col sm={12} md={12} lg={4} xl={4}>
                {!isEmpty(data) ? (
                  <AssociationDetails
                    idAssociation={data.id}
                    image={
                      data.image
                        ? "data:" + data.image_type + ";base64," + data.image
                        : "/no_img.png"
                    }
                    name={data.name}
                    address={data.address}
                    dateOfFoundation={data.date_of_foundation}
                  />
                ) : null}
              </Col>
              <Col sm={12} md={12} lg={8} xl={8}>
                <Stack gap={3}>
                  {!isEmpty(data) ? (
                    <Stack
                      direction="horizontal"
                      gap={3}
                      className="statistics-container d-flex justify-content-between align-items-center"
                    >
                      <StatisticBox
                        icon={
                          <FavoriteBorderIcon
                            style={{ height: "35px", width: "35px" }}
                          />
                        }
                        number={data.number_like}
                        firstWord={"Like"}
                        text={t("dashboard.like_text")}
                      />
                      <StatisticBox
                        icon={
                          <PersonAddAltIcon
                            style={{ height: "35px", width: "35px" }}
                          />
                        }
                        number={data.followers}
                        firstWord={"Follower"}
                        text={t("dashboard.follower_text")}
                      />
                      <StatisticBox
                        icon={
                          <TouchAppOutlinedIcon style={{ color: "#03626e" }} />
                        }
                        number={data.traffic_association}
                        firstWord={t("dashboard.view")}
                        text={t("dashboard.view_text")}
                      />
                    </Stack>
                  ) : null}
                  {isPC && !isEmpty(data.volunteer) ? (
                    <VolunteerTable data={data.volunteer} />
                  ) : null}
                </Stack>
              </Col>
            </Row>
          </Stack>

          {/**Opzioni della dashboard*/}
          <Stack gap={1}>
            <span className="paragraph-title-dashboard">
              {t("dashboard.options")}
            </span>
            <Row sm={1} md={1} lg={2} xl={2} className="g-2">
              {options
                ? options.map((item, index) => {
                    let numberRequest = null;
                    if (item.text === "dashboard.request_volunteer")
                      numberRequest = data.number_volunteer_requests;

                    if (item.text === "dashboard.request_shift")
                      numberRequest = data.number_shift_requests;

                    if (item.text === "dashboard.question")
                      numberRequest = data.number_question;

                    return (
                      <Col sm={12} md={12} lg={6} xl={6} key={index}>
                        <OptionBox
                          text={t(item.text)}
                          icon={item.icon}
                          link={
                            item.link
                              ? item.link.replace(
                                  "{{id_association}}",
                                  id_association
                                )
                              : null
                          }
                          numberRequest={numberRequest}
                          callback={
                            item.text === "dashboard.volunteer_invitation"
                              ? () => setShowInviteModal(true)
                              : null
                          }
                        />
                      </Col>
                    );
                  })
                : null}
            </Row>
          </Stack>
        </Stack>
        <VoidSpace />
      </div>
      <InviteModal
        show={showInviteModal}
        setShow={setShowInviteModal}
        inviteLink={`${process.env.REACT_APP_BASE_URL}invitation-volunteer/${id_association}`}
      />
    </>
  );
};

export default Dashboard;
